import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';

import { Button, Paper, MenuItem, Radio, Typography, Divider } from 'material-ui';
import Select from 'react-select';
import 'react-select/dist/react-select.css'
import TextField from 'material-ui/TextField';
import ReactTable from "react-table";
import Loader from "other-components/loader/loader";
import printjs from 'print-js';
import axios from 'axios';
import $ from "jquery";
import { CSVLink, CSVDownload } from 'react-csv';
import moment from 'moment';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui/Dialog';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import { withAlert } from 'react-alert';

const styles = theme => ({
    layoutRoot: {},

});

class TrailBalance extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {

            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            allAccounts: [],

            creditTotal: 0,
            debitTotal: 0,

            dateRange: '',

        };

        this.loadCurrentDate();

        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleToDateChange = this.handleToDateChange.bind(this);

    }

    // get current date
    loadCurrentDate() {
        var date = new Date();
        var formatedDate = (date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()).toString();
        this.setState({ fromDate: formatedDate });
        this.setState({ toDate: formatedDate });
    }

    // set transaction date
    handleFromDateChange(date) {

        $('#toDateDev').css('display', 'block');
        this.setState({ fromDate: date });


    }

    // set payment closr date
    handleToDateChange(date) {

        this.setState({ toDate: date });

        // var toDate = new Date(date);
        // var fromDate = new Date(this.state.fromDate);

        // fromDate.setHours(0);
        // fromDate.setMinutes(0);
        // fromDate.setSeconds(0);
        // console.log(fromDate);

        // toDate.setHours(0);
        // toDate.setMinutes(0);
        // toDate.setSeconds(0);
        // console.log(toDate);

        // if ((toDate > fromDate) || (toDate.toDateString() === fromDate.toDateString())) {

        //     console.log("feture date");
        //     this.setState({ toDate: date });

        //     // set date range
        //     if (null == this.state.fromDate || '' == this.state.fromDate || undefined == this.state.fromDate) {
        //         var dateRange = '';

        //     } else {

        //         var formatedFromDate = (fromDate.getFullYear() + '/' + (fromDate.getMonth() + 1) + '/' + fromDate.getDate()).toString();
        //         var formatedToDate = (toDate.getFullYear() + '/' + (toDate.getMonth() + 1) + '/' + toDate.getDate()).toString();

        //         var dateRange = formatedFromDate + " to " + formatedToDate;
        //         this.setState({ dateRange: dateRange });
        //     }

        // } else {
        //     console.log("Date pass date");

        //     this.setState({ toDate: '' });
        //     this.props.alert.error("Date Range Incorrect !");
        // }

    }

    handleTextBoxChange = name => event => {
        var fromAmount = this.state.amount;
        this.setState({ [name]: event.target.value });
        // if ('amount' == [name][0]) {

        // } else {

        // }

    };

    // get all accounts which selected date
    getAllAccounts() {
        this.setState({ loading: true });

        var toDate = new Date(this.state.toDate);
        var fromDate = new Date(this.state.fromDate);

        fromDate.setHours(0);
        fromDate.setMinutes(0);
        fromDate.setSeconds(0);

        toDate.setHours(0);
        toDate.setMinutes(0);
        toDate.setSeconds(0);

        if ((toDate > fromDate) || (toDate.toDateString() === fromDate.toDateString())) {

            var dateObj = {
                fromDate: this.state.fromDate,
                toDate: this.state.toDate
            };

            var formatedFromDate = (fromDate.getFullYear() + '/' + (fromDate.getMonth() + 1) + '/' + fromDate.getDate()).toString();
            var formatedToDate = (toDate.getFullYear() + '/' + (toDate.getMonth() + 1) + '/' + toDate.getDate()).toString();

            var dateRange = formatedFromDate + " to " + formatedToDate;
            this.setState({ dateRange: dateRange });

            // axios.post('http://localhost:5009/trailBalance/getAllAccountCRandDRSum', dateObj)
            axios.post(window.accountServer + '/trailBalance/getAllAccountCRandDRSum', dateObj)
                .then(response => {

                    if (null == response || undefined == response || 0 == response.data.resultAccount.length) {
                        this.setState({
                            loading: false,
                            allAccounts: []
                        });
                    } else {

                        if (response.data.success) {
                            var allAccounts = [];
                            var creditTotal = 0;
                            var debitTotal = 0;

                            for (let i = 0; i < response.data.resultAccount.length; i++) {

                                var debitAccTotal = 0;
                                var creditAccTotal = 0;
                                if ("ASSET" == response.data.resultAccount[i].ACCOUNT_TYPE || "EXPENSE" == response.data.resultAccount[i].ACCOUNT_TYPE) {

                                    var crSum = response.data.resultAccount[i].CR_SUM;
                                    var drSum = response.data.resultAccount[i].DR_SUM;

                                    if (null == response.data.resultAccount[i].CR_SUM || undefined == response.data.resultAccount[i].CR_SUM || '' == response.data.resultAccount[i].CR_SUM) {
                                        crSum = 0;
                                    }

                                    if (null == response.data.resultAccount[i].DR_SUM || undefined == response.data.resultAccount[i].DR_SUM || '' == response.data.resultAccount[i].DR_SUM) {
                                        drSum = 0;
                                    }

                                    debitAccTotal = (parseFloat(drSum) - parseFloat(crSum));
                                }

                                if ("INCOME" == response.data.resultAccount[i].ACCOUNT_TYPE || "LIABILITY" == response.data.resultAccount[i].ACCOUNT_TYPE
                                    || "EQUITY" == response.data.resultAccount[i].ACCOUNT_TYPE) {

                                    var crSum = response.data.resultAccount[i].CR_SUM;
                                    var drSum = response.data.resultAccount[i].DR_SUM;

                                    if (null == response.data.resultAccount[i].CR_SUM || undefined == response.data.resultAccount[i].CR_SUM || '' == response.data.resultAccount[i].CR_SUM) {
                                        crSum = 0;
                                    }

                                    if (null == response.data.resultAccount[i].DR_SUM || undefined == response.data.resultAccount[i].DR_SUM || '' == response.data.resultAccount[i].DR_SUM) {
                                        drSum = 0;
                                    }

                                    creditAccTotal = (parseFloat(crSum) - parseFloat(drSum));
                                }

                                allAccounts.push({
                                    accId: response.data.resultAccount[i].ID_LEDGER_ACCOUNT,
                                    accountNo: response.data.resultAccount[i].LEDGER_REF_NO,
                                    accountName: response.data.resultAccount[i].NAME,
                                    debit: debitAccTotal,
                                    credit: creditAccTotal
                                });

                                debitTotal = (debitTotal + debitAccTotal);
                                creditTotal = (creditTotal + creditAccTotal);

                                // if (null == response.data.resultAccount[i].CR_SUM || undefined == response.data.resultAccount[i].CR_SUM || '' == response.data.resultAccount[i].CR_SUM) {
                                //     creditTotal = (creditTotal + 0);
                                // } else {
                                //      creditTotal = (creditTotal + parseFloat(response.data.resultAccount[i].CR_SUM));
                                // }

                                // if (null == response.data.resultAccount[i].CR_SUM || undefined == response.data.resultAccount[i].CR_SUM || '' == response.data.resultAccount[i].CR_SUM) {
                                //     debitTotal = (debitTotal + 0);
                                // } else {
                                //     debitTotal = (debitTotal + parseFloat(response.data.resultAccount[i].DR_SUM));
                                // }


                            }
                            this.setState({ allAccounts: allAccounts });
                            this.setState({ creditTotal: creditTotal.toFixed(2) });
                            this.setState({ debitTotal: debitTotal.toFixed(2) });
                            this.setState({ loading: false });
                        } else {

                            this.props.alert.error("Incorrect Date Range");
                            this.setState({ loading: false });
                        }
                    }


                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        } else {
            this.props.alert.error("Date Range Incorrect !");
            var dateRange = '';
            this.setState({ loading: false });
        }

    }

    // print trail balance
    printTrailBalance() {
        this.setState({ loading: true });

        if (null == this.state.fromDate || '' == this.state.fromDate || undefined == this.state.fromDate ||
            null == this.state.toDate || '' == this.state.toDate || undefined == this.state.toDate) {
            this.props.alert.error("Date Range Incorrect !");
            this.setState({ loading: false });
        } else {

            var toDate = new Date(this.state.toDate);
            var fromDate = new Date(this.state.fromDate);

            fromDate.setHours(0);
            fromDate.setMinutes(0);
            fromDate.setSeconds(0);

            toDate.setHours(0);
            toDate.setMinutes(0);
            toDate.setSeconds(0);

            if ((toDate > fromDate) || (toDate.toDateString() === fromDate.toDateString())) {

                var dateObj = {
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate
                };

                var formatedFromDate = (fromDate.getFullYear() + '/' + (fromDate.getMonth() + 1) + '/' + fromDate.getDate()).toString();
                var formatedToDate = (toDate.getFullYear() + '/' + (toDate.getMonth() + 1) + '/' + toDate.getDate()).toString();

                var dateRange = formatedFromDate + " to " + formatedToDate;
                this.setState({ dateRange: dateRange });


                var address = null;

                // axios.get('http://localhost:5008/trailBalanceReport/getTrailBalanceReport', {
                axios.get(window.reportServer + '/trailBalanceReport/getTrailBalanceReport', {
                    params: {
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate
                    }
                })
                    .then(response => {
                        address = response.data.path;
                        address = window.reportServer + "/" + address;
                        // address = "http://localhost:5008/" + address;

                        //this.setState({ address: address });

                        const url = address;
                        // window.open(url, '_blank');
                        printjs({ printable: address, type: 'pdf', showModal: true })
                        this.setState({ loading: false });
                    });



            } else {
                this.props.alert.error("Date Range Incorrect !");
                var dateRange = '';
                this.setState({ loading: false });
            }
        }

    }

    render() {

        const { classes } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24"><h2 className="subtitle-color">Trial Balance</h2></div>
                    }
                    content={
                        <div className="p-24 {classes.root}">
                            <div className="p-24 {classes.root} ">

                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-1/5 inline-block">
                                        <p>From Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleFromDateChange}
                                            selectedDays={this.state.fromDate}
                                            value={this.state.fromDate}
                                            onChange={this.handleTextBoxChange('fromDate')}
                                        />
                                    </div>

                                    <div className="w-full md:w-1/5 inline-block" id="toDateDev">
                                        <p>To Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleToDateChange}
                                            selectedDays={this.state.toDate}
                                            value={this.state.toDate}
                                            onChange={this.handleTextBoxChange('toDate')}

                                        />
                                    </div>

                                    <div className="w-full md:w-3/5 float-right mb-16">

                                        <Button type="button" onClick={(ev) => this.getAllAccounts()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin ">
                                            View
                                        </Button>

                                        {/* <Button type="button" onClick={(ev) => this.sendEmail()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin  ">
                                            Email
                                         </Button> */}

                                        <Button type="button" onClick={(ev) => this.printTrailBalance()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin ">
                                            Print
                                        </Button>
                                        <CSVLink data={this.state.allAccounts} filename={"trail_balance_report.csv"} target="_blank">
                                            <Button type="button" variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin">
                                                Export
                                            </Button>
                                        </CSVLink>
                                    </div>

                                </div>
                                <Divider className="md:mt-16 sm:mt-8 inter-acco-margin" />
                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-4/5 inline-block"> </div>

                                    <div className="w-full md:w-1/5 inline-block">
                                        <label><strong>Industrial Calibration & Services Center (Pvt) Ltd</strong></label>
                                        {/* <TextField
                                            className="w-full"
                                            type="text"
                                            name="bussinessName"
                                            label="Bussiness Name"
                                            value={this.state.bussinessName}
                                            onChange={this.handleTextBoxChange('bussinessName')}
                                            disabled
                                        /> */}
                                    </div>

                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-4/5 inline-block"> </div>

                                    <div className="w-full md:w-1/5 inline-block">
                                        <label><strong>Date Range : </strong> {this.state.dateRange}</label>
                                    </div>

                                </div>

                                <div class="w-full bg-white h-auto mt-8">
                                    <ReactTable
                                        getTrProps={(state, rowInfo, column) => {
                                            return {
                                                className: "cursor-pointer",
                                                onClick: (e, handleOriginal) => {

                                                }
                                            }
                                        }}
                                        data={this.state.allAccounts}
                                        columns={[
                                            {
                                                Header: "rowId",
                                                accessor: "rowId",
                                                show: false
                                            },

                                            {
                                                Header: "Ledger Account Id",
                                                accessor: "accId",
                                                show: false
                                            },
                                            {
                                                Header: "Account No",
                                                accessor: "accountNo",
                                                className: "justify-start",
                                                filterable: true
                                            },

                                            {
                                                Header: "Account Name",
                                                accessor: "accountName",
                                                className: "justify-start",
                                                filterable: true,
                                                Footer: (
                                                    <span>
                                                        <div align="right" className="w-full">
                                                            <strong>
                                                                Total :
                                                            </strong>
                                                        </div>
                                                    </span>
                                                )
                                            },
                                            {
                                                Header: "Debit",
                                                accessor: "debit",
                                                className: "justify-end",
                                                filterable: true,
                                                Footer: (
                                                    <span>
                                                        <div align="right" className="w-full">
                                                            <strong>
                                                                {this.state.debitTotal}

                                                            </strong>
                                                        </div>
                                                    </span>
                                                )
                                            },
                                            {
                                                Header: "Credit",
                                                accessor: "credit",
                                                className: "justify-end",
                                                filterable: true,
                                                Footer: (
                                                    <span>
                                                        <div align="right" className="w-full">
                                                            <strong>
                                                                {this.state.creditTotal}
                                                            </strong>
                                                        </div>
                                                    </span>
                                                )

                                            },


                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />

                                </div>

                                <Divider className="md:mt-16 sm:mt-8" />
                            </div>

                        </div>
                    }
                />
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(TrailBalance));


// WEBPACK FOOTER //
// ./src/main/content/accountingReports/trailBalance/TrailBalance.js